import QuillTableModule from 'quill/modules/table';
import {
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from './formats/Table';
import type { Registry } from './types';

// @ts-expect-error
class TableModule extends QuillTableModule {
  static register(registry: Registry) {
    registry.register(TableCell);
    registry.register(TableRow);
    registry.register(TableBody);
    registry.register(TableContainer);
  }
}

export default TableModule;
